import { createSelector } from 'reselect'

export const selectCurrentlyDisplayedUsers = createSelector(
  (s) => s.CurrentlyDisplayedUsers.users,
  (users) => users,
)

export const selectTotalDisplayableUsers = createSelector(
  (s) => s.CurrentlyDisplayedUsers.totalRows,
  (users) => users,
)
